module.exports = __webpack_public_path__ + "static/media/incoming-call.30179aab.svg";